"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        variants = _ref.variants;
    addUtilities({
      '.text-left': {
        'text-align': 'left'
      },
      '.text-center': {
        'text-align': 'center'
      },
      '.text-right': {
        'text-align': 'right'
      },
      '.text-justify': {
        'text-align': 'justify'
      }
    }, variants('textAlign'));
  };
}